<template>
	<div class="messages">
		<MessageNav
            v-if="unseenCount"
			v-model="filters.type"
			@input="changeTab"
			:unread="unseenCount"
		/>

		<section
			class="messages__list-section"
			v-if="filters.type !== 'compose'"
		>
			<div
				v-if="messages.data.length"
				class="messages__search"
			>
				<AppTextField
					class="search"
					placeholder="Search"
					icon-right="search"
					v-model="filters.keyword"
					@input="search"
				/>
			</div>

			<MessageList
				class="messages__list"
				@loadMore="getMessageList"
				:active-tab="filters.type"
			/>
		</section>

		<MessageCompose
      ref="compose"
			v-if="filters.type === 'compose'"
			class="messages__view-section message"
			@back="exitCompose"
		/>

		<MessageSent
			class="messages__view-section"
			v-else-if="filters.type === 'sent'"
		/>

		<MessageInbox
      ref="inbox"
			v-else
			class="messages__view-section"
		/>

		<AppPopup
			:visible="modalName.includes('discard-message')"
			type="warning"
			title="Warning"
			message="All your inputs will be gone"
			@close="$store.dispatch('closeModal')"
		>
			<AppButton
				@click="$store.dispatch('confirm')"
				modifier="small-primary"
			>Ok</AppButton>
			<AppButton
				@click="$store.dispatch('closeModal')"
				modifier="small-danger"
			>Cancel</AppButton>
		</AppPopup>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import * as messageModule from '@/store/message'
import MessageFilter from '@/class/MessageFilter.js'
import MessageNav from '@/components/messages/MessageNav.vue'
import MessageList from '@/components/messages/MessageList.vue'
import MessageInbox from '@/components/messages/MessageInbox.vue'
import MessageCompose from '@/components/messages/MessageCompose.vue'
import MessageSent from '@/components/messages/MessageSent.vue'

export default {
	data () {
		return {
			filters: {
				type: 'inbox',
				page: 0,
				keyword: ''
			}
		}
	},

	computed: {
		...mapFields('message', {
			selectedMessage: 'selectedMessage',
			messages: 'messages',
			unseenCount: 'unseenCount'
		}),

		...mapGetters({
			modalName: 'modalName'
		})
	},

	beforeRouteLeave (to, from, next) {
		if (this.$refs.compose) this.$refs.compose.discard(true, next)
		else if (this.$refs.inbox) this.$refs.inbox.discard(true, next)
		else {
			this.$store.dispatch('message/clearData')
			next()
		}
	},

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['message/']) {
			this.$store.registerModule('message', messageModule.default)
		}
	},

	created () {
		const {
			type,
			keyword
		} = this.$route.query

		if (keyword) {
			this.filters.keyword = keyword
		}

		if (type) {
			this.filters.type = type
		}

		this.getMessageList()
		this.$store.dispatch('message/getCount')
	},

	methods: {
		getMessageList () {
			this.filters.page++
			const { type, keyword } = this.filters
			const { apiQuery, routerQuery } = new MessageFilter(this.filters)
			if (!['compose', 'sent'].includes(type)) {
				this.$store.dispatch('message/getList', apiQuery)
				this.$router.push({ query: routerQuery })
				return
			}

			if (type === 'sent') {
				this.$store.dispatch('message/getSent', keyword)
				this.$router.push({ query: routerQuery })
			}
		},

		changeTab () {
			this.$store.commit('message/clearSelectedMessage')

			if (this.filters.type !== 'compose') {
				this.filters.page = 0
				this.filters.keyword = ''
				this.messages = {
					data: [],
					current_page: 0,
					last_page: 0
				}

				this.getMessageList()
			}
		},

		exitCompose () {
			this.filters.type = 'inbox'
			this.changeTab()
		},

		search () {
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.filters.page = 0
				this.messages = {
					data: [],
					current_page: 0,
					last_page: 0
				}
				this.selectedMessage.id = 0
				this.getMessageList()
			}, 500)
		}
	},

	components: {
		MessageNav,
		MessageList,
		MessageInbox,
		MessageCompose,
		MessageSent
	}
}
</script>

<style lang="scss" scoped>
.messages {
	height: 100%;
	border-radius: 10px;
	display: flex;
	overflow: hidden;

	&__list-section {
		height: 100%;
		width: 350px;
		flex-shrink: 0;
		display: flex;
		flex-direction: column;
		background-color: #fff;
	}

	&__search {
		padding: 15px 30px;
		border-bottom: 0.5px solid lighten($default-light, 12%);

		.search {
			width: 100%;
		}
	}

	&__list {
		flex: 1 1 auto;
		height: 100%;
	}

	&__view-section {
		flex: 1 1 auto;
		height: 100%;
		overflow-y: auto;
	}
}
</style>
